
import React from 'react'
import { Modal,message,} from 'antd';
import { useShangpingdingdanDelMutation, } from '../../store/ReactWebSiteApi';
function WebGoodsOrderDel(props) {
    //删除产品-----------------------------------------------------------------------------------------------------------------------------删除产品
    const {confirm} = Modal; 
    const [submitDel] = useShangpingdingdanDelMutation()
    return (
        <>
            <a onClick={() => {
                            confirm({
                                title: '确定删除吗?',
                                content: '删除后不能恢复',
                                okText: '确认',
                                okType: 'danger',
                                cancelText: '取消',
                                onOk() {
                                    submitDel({dd_id:props.dd_id}).then((res) => {
                                        // console.log(res);
                                        if (res.data.Status === 'success') {
                                            message.info('删除成功！');
                                        }
                                        if (res.data.Status === "fail") {
                                            message.error('删除失败！'+res.data.Message)
                                        }
                                    })
                                },
                                onCancel() {
                                console.log('Cancel');
                                },
                            });
                        }}>删除</a>
        </>
    )
}

export default WebGoodsOrderDel